const activationErrorKeys = {
    TRIAL_ACTIVATION_ALREADY_PENDING: 'billing.subscriptions.activationInvoicePendingError',
    TRIAL_ACTIVATION_PAYMENT_ALREADY_RECORDED: 'billing.subscriptions.activationPaymentRecordedError',
}

export function planChangeErrorMessage(error, translate) {
    const key = activationErrorKeys[error?.code]
    return key
        ? translate(key)
        : error?.message || translate('Unknown error')
}
